// extracted by mini-css-extract-plugin
module.exports = {"fullBody":"full-body_fullBody__3Yl5S","menuList":"full-body_menuList__2hq_h"};